// mediaTagging/structuredTags.js — converts the get_document_tags structured response into the shape the
// tagging UI + topoEditor consume.
//
// The new endpoint returns each box's keywords as { text, hidden } objects (plan mediatagging_topo2_fusion,
// phase editor-tag-hidden). This module bridges them back to the legacy comma-string `text` (so mountTagBox
// stays unchanged) and derives the per-box hidden keyword list for the editor's hidden-keyword decoration.
// Keeping this tagging-specific knowledge here lets the topoEditor stay generic (plain-text value model).

// One structured box → the tag object the tagging UI uses, augmented with `hidden` (this box's hidden
// keyword texts). `text` is the comma-joined keyword list, matching getTags()'s ', ' separator.
export function structuredBoxToTag(box) {
    const keywords = Array.isArray(box.keywords) ? box.keywords : [];
    return {
        ...box,
        text: keywords.map((k) => k.text).join(", "),
        hidden: keywords.filter((k) => k.hidden).map((k) => k.text),
    };
}

// The whole response.data (array of boxes) → tag objects ready for mounting.
export function structuredTagsToTags(data) {
    return (Array.isArray(data) ? data : []).map(structuredBoxToTag);
}
